import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import React from 'react';

const SliderSettings = ({slidelist, slidesToShow, slidesToShowTab, slidesToShowMobile, centerMode, centerPadding, autoplay}) => {
  const settings = {
    arrow: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow ? slidesToShow : 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: autoplay ? autoplay : false,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShowTab ? slidesToShowTab : 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: centerMode ? centerMode : false,
          centerPadding: centerPadding ? centerPadding : '5%',
          slidesToShow: slidesToShowMobile ? slidesToShowMobile : 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: slidesToShowMobile ? slidesToShowMobile : 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        {slidelist}
      </Slider>
    </div>
  );
};
export default SliderSettings;
